export default "__VITE_ASSET__DT_skOkP__";